import { object, string } from 'yup';

import { getQuillPlainText } from '../../../components/baseV2';
import { TEXT_AREA_MAX_LENGTH } from '../constants';

// The API caps the stored HTML. Markup can exceed that limit while the visible text still fits.
export const CHILD_BEHAVIOR_ISSUES_SCHEMA = object({
  child_behavior_issues: string()
    .max(TEXT_AREA_MAX_LENGTH, `Must be at most ${TEXT_AREA_MAX_LENGTH} characters`)
    .test(
      'max-text-length',
      `Must be at most ${TEXT_AREA_MAX_LENGTH} characters`,
      (value) => getQuillPlainText(value).length <= TEXT_AREA_MAX_LENGTH,
    ),
});
